import React from 'react'
import PropTypes from 'prop-types'
import { Box, Flex, Image } from '@chatterbug/aaron'

import rightArrow from 'src/ui/assets/icons/right-arrow.svg'
import dragHandle from 'src/ui/assets/icons/drag-handle.svg'

import ListItemInfo from '../ListItemInfo/ListItemInfo'

const LIST_ITEM_SIZES = {
  md: {
    container: {
      padding: '2x',
    },
    icon: {
      width: '72px',
      height: '72px',
      marginRight: '3x',
      flexShrink: 0,
    },
  },
  sm: {
    container: {
      padding: '3x',
    },
    icon: {
      width: '56px',
      height: '56px',
      marginRight: '3x',
      flexShrink: 0,
    },
  },
}

/**
 * The `ListItem` is used in a `List`
 *
 */
const ListItem = ({
  draggable,
  name,
  size = 'md',
  iconUrl,
  iconShape,
  state,
  tooltip,
  renderFooter,
}) => {
  const sx = LIST_ITEM_SIZES[size]
  return (
    <Box
      sx={{
        width: '100%',
        color: 'black0',
        borderRadius: '1x',
        padding: '2x',
        boxShadow: 'raised',
        backgroundColor: 'white100',
        paddingRight: '56px', // to account for the "arrow" background image.
        backgroundImage: `url(${rightArrow})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right 16px top 50%',
        cursor: 'pointer',
        ':active': {
          boxShadow: 'pressed',
        },
        ...sx.container,
      }}
    >
      <Flex justifyContent="space-between" alignItems="center">
        <Flex alignItems="center" flex="1">
          {draggable && (
            <Image src={dragHandle} width={24} height={24} mr="1x" />
          )}
          <ListItemInfo
            name={name}
            iconSx={sx.icon}
            iconUrl={iconUrl}
            iconShape={iconShape}
            renderFooter={renderFooter}
            tooltip={tooltip}
          />
        </Flex>
        {state}
      </Flex>
    </Box>
  )
}

ListItem.propTypes = {
  draggable: PropTypes.bool,
  size: PropTypes.oneOf(Object.keys(LIST_ITEM_SIZES)),
  iconUrl: PropTypes.string,
  iconShape: PropTypes.oneOf(['rounded']),
  name: PropTypes.string.isRequired,
  state: PropTypes.any,
  renderFooter: PropTypes.any,
  tooltip: PropTypes.string,
}

export default ListItem
